import {useEffect, useState} from "@wordpress/element";
import apiFetch from '@wordpress/api-fetch';
import DOMPurify from 'dompurify';
import {__} from '@wordpress/i18n';

export const Popup = ({show, popupPageId}) => {
	const [content, setContent] = useState(false);
	const [title, setTitle] = useState(false);

	useEffect(() => {
		if (!show) return;

		apiFetch({path: '/wp/v2/pages/' + popupPageId}).then((page) => {
			setContent(
				DOMPurify.sanitize(page.content.rendered)
			);
			setTitle(page.title.rendered);
		}).catch((err) => {
        setContent(__('Failed to load content'));
    })
	}, [show])

	return (
		<>
			<div class="wccsq-popup-wrap" id={"wccsq-popup-" + popupPageId}>
				<div class="wccsq-popup-bg" style={{display: (show ? 'block' : 'none')}}></div>
				<div class="wccsq-popup" style={{display: (show ? 'block' : 'none')}} role="dialog" aria-describedby="wccsq-popup-body" aria-label={title}>
					<span class="wccsq-close"></span>
					<div class="wccsq-body" id="wccsq-popup-body" dangerouslySetInnerHTML={{ __html: content }}>
						{/* Content is inserted here */}
					</div>
				</div>
			</div>
		</>
	)
}
